import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let Spinner = class Spinner extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "spinnerSize", void 0);
    _defineProperty(this, "spinnerColor", void 0);
    _defineProperty(this, "loaderMsg", void 0);
    _defineProperty(this, "fullScreen", void 0);
  }
};
__decorate([Prop({
  default: 'spinnersNormal'
})], Spinner.prototype, "spinnerSize", void 0);
__decorate([Prop({
  default: 'darkSpinner'
}) //lightSpinner
], Spinner.prototype, "spinnerColor", void 0);
__decorate([Prop()], Spinner.prototype, "loaderMsg", void 0);
__decorate([Prop({
  default: false
})], Spinner.prototype, "fullScreen", void 0);
Spinner = __decorate([Component({})], Spinner);
export default Spinner;